import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {eho_articles} from "./eho_ceha_articles";

import styles from "./EhoZin.module.scss";


export const EhoAuthor = () => {
  const navigate = useNavigate();
  const {id} = useParams();
  const [numPoem, setNumPoem] = useState(0);
  const [poem, setPoem] = useState(eho_articles[id]['poems'][0]);
  const [poems, setPoems] = useState(eho_articles[id]);


  useEffect(() => {
    setPoem(eho_articles[id]['poems'][numPoem])
  },[numPoem])

  useEffect(() => {
    setNumPoem(0);
    setPoem(eho_articles[id]['poems'][0])
    setPoems(eho_articles[id]);
  },[id])

  const nextPoem = () => {
    setNumPoem(numPoem + 1);
    window.scrollTo(0, 0);
  }

  const prevPoem = () => {
    setNumPoem(numPoem - 1);
    window.scrollTo({top: 0,
      left: 0,
      behavior: "smooth"});
  }

  return (
    <div className={styles.ehoZinWrapper}>
      {poems && poem && id != 0 && (
        <div className={styles.ehoZinAuthorPage}>
          <div className={styles.poemTextArea}>
              <p className={styles.poemAuthorTitle}>{poems.author}</p>
              <p className={styles.poemTitle}>{poem.title} </p>
              <p dangerouslySetInnerHTML={{ __html: poem.text }}></p>
          </div>

          <div className={styles.ehoNavPanel}>
            {numPoem !== 0 && (
              <p onClick={prevPoem}>Предыдущий Стих</p>
            )}
            {numPoem !== eho_articles[id]['poems'].length - 1  && (
              <p onClick={nextPoem}>Следующий Стих</p>

            )}
          </div>
          <div className={styles.ehoNavPanel}>
            <p onClick={() => navigate(`/zins/eho`)}>На главную</p>
            <p onClick={() => navigate("/zins/eho/authors/" + (Number(id) - 1))}>Предыдущий Автор</p>
            {id != 14 && (
              <p onClick={() => navigate("/zins/eho/authors/" + (Number(id) + 1))}>Следующий Автор</p>
            )}
          </div>
        </div>
      )}

      {id == 0 && (
        <div className={styles.ehoZinAuthorPage}>
          <div className={styles.poemTextArea} dangerouslySetInnerHTML={{ __html: poem.text }}>
          </div>
          <div className={styles.ehoNavPanel}>
						<p onClick={() => navigate(`/zins/eho`)}>На главную</p>
            <p onClick={() => navigate("/zins/eho/authors/1")}>Следующий Автор</p>
          </div>
        </div>
      )}

    </div>
  );

};
